export class CategoryListModel {
    id: number;
    name: any = null;
    photo: string;
    top_flag: number = 0;
    status: boolean; 
}
